import { render, staticRenderFns } from "./ItemRow.vue?vue&type=template&id=9d52a95a&scoped=true&"
import script from "./ItemRow.vue?vue&type=script&lang=ts&"
export * from "./ItemRow.vue?vue&type=script&lang=ts&"
import style0 from "./ItemRow.vue?vue&type=style&index=0&id=9d52a95a&lang=scss&scoped=true&"
import style1 from "./ItemRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d52a95a",
  null
  
)

export default component.exports